import React from 'react'
import PropTypes from 'prop-types'

import { Card, Typography } from '@chilecompra/react-kit/components'
import { CANCELLATION_TYPE_DICTIONARY } from '../../config/settings/constants'

import { GridContainer, GridItem } from './QuoteBasicInformation.styles'

/**
 * Cancellation component.
 */
const Cancellation = props => {
  const { reasonCancellation, cancellationType } = props

  return (
    <GridContainer padding="0 0 4px">
      <GridItem xs={12}>
        <Card color="error">
          <GridContainer>
            <GridItem xs={12}>
              <Typography color="black1" fontWeight="bold" variant="h4">
                Motivo de cancelación
              </Typography>
            </GridItem>
            {cancellationType && cancellationType === CANCELLATION_TYPE_DICTIONARY.MANUAL && (
              <GridItem xs={12}>
                <Typography color="black3" variant="body2">
                  Ingresado por usuario comprador
                </Typography>
              </GridItem>
            )}
          </GridContainer>
          <GridContainer margin="5px 0 0">
            <GridItem xs={12}>
              <Typography color="black1" fontSize="14px" lineHeight="18px" margin="8px 0 0" variant="body2">
                {reasonCancellation}
              </Typography>
            </GridItem>
          </GridContainer>
        </Card>
      </GridItem>
    </GridContainer>
  )
}

Cancellation.propTypes = {
  reasonCancellation: PropTypes.string.isRequired,
  cancellationType: PropTypes.string
}

export default Cancellation
